module.exports = __webpack_public_path__ + "media/images/countryrect/dj-0154ce11e372c19269956540651cb46a.svg";